
import categoryJsonld from "@/mixins/jsonld/category";
import breadcrumbsJsonld from "@/mixins/jsonld/breadcrumbs";
import { stripHtml } from "@/utils/stripHTML";
import { isElectricHeatersCategory } from "@/utils/heaterCalculator";

export default {
  mixins: [categoryJsonld, breadcrumbsJsonld],

  props: {
    name: { type: String, default: null },
    slug: { type: String, default: null },
    treeId: { type: String, default: null },
    webDescr2: { type: String, default: null },
    webDescr3: { type: String, default: null },
    meta_title: { type: String, default: null },
    meta_descr: { type: String, default: null },
    // INVENTRE.SHOW_SEARC. Defaults to true so an older backend that does not send
    // the field yet keeps behaving as before -- frontend and backend deploy as
    // separate containers, and silently noindexing the catalogue would be far worse
    // than briefly indexing a parts folder.
    searchable: { type: Boolean, default: true },
    hasChilds: { type: Boolean, default: false },
    hasParent: { type: Boolean, default: false },
    parentAutoid: { type: String, default: null },
    breadcrumbs: { type: Array, default: () => [] },
    photo: { type: String, default: null },
    categories: { type: Array, default: () => [] },
    products: { type: Array, default: () => [] },
    pagination: { type: Object, default: null },
  },

  computed: {
    isElectricHeaters() {
      return isElectricHeatersCategory(this.treeId);
    },

    SEO() {
      return {
        index: this.searchable,
        follow: true,
        title: this.meta_title || this.name,
        description: this.meta_descr || stripHtml(this.webDescr2),
        image: this.photo,
        canonical: `/${this.slug}`,
        scripts: [
          this.categoryJsonldScript,
          this.breadcrumbsJsonldScript,
        ].filter(Boolean),
      };
    },

    getPreviousCategory() {
      if (this.hasParent) {
        return {
          treeId: this.parentAutoid,
          name: this.breadcrumbs?.at(-1)?.name || "Store",
        };
      }
      return { treeId: "", name: "Store" };
    },
  },
};
